/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorDelinquentReportsTable.vue?vue&type=template&id=3ab0e0ef&scoped=true"
import script from "./DoctorDelinquentReportsTable.vue?vue&type=script&lang=js"
export * from "./DoctorDelinquentReportsTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorDelinquentReportsTable.vue?vue&type=style&index=0&id=3ab0e0ef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab0e0ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab0e0ef')) {
      api.createRecord('3ab0e0ef', component.options)
    } else {
      api.reload('3ab0e0ef', component.options)
    }
    module.hot.accept("./DoctorDelinquentReportsTable.vue?vue&type=template&id=3ab0e0ef&scoped=true", function () {
      api.rerender('3ab0e0ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DoctorDelinquentReportsTable.vue"
export default component.exports